import * as Colors from 'src/theme/colors';

export default {
  root: {
    backgroundColor: Colors.DividersAndCardBorders,
  },
};
